export default __webpack_public_path__ + "static/media/Bild3.ea65fa41.jpeg";